const onTouchendDirectiveDefinition = () => ({
    restrict: 'A',
    link(scope, element, attrs) {
        function onTouchEnd(event) {
            scope.$apply(() => scope.$evalAsync(attrs.olyOnTouchend, { $event: event }));
        }

        element.bind('touchend', onTouchEnd);
    },
});

module.exports = { onTouchendDirectiveDefinition };



// WEBPACK FOOTER //
// ./src/olycommon/ontouchend/on-touchend.directive.js